{
  "version": 1,
  "asset_id": "00f961c0-8ceb-451c-8547-95085177de3e",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/00f961c0-8ceb-451c-8547-95085177de3e/hiatal-normal-v3-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/00f961c0-8ceb-451c-8547-95085177de3e/hiatal-normal-v3-1200.webp",
  "original_filename": "hiatal-normal-v3-1200.webp",
  "size": 159682,
  "content_type": "image/webp",
  "created_at": "2026-10-28T23:12:13Z"
}
